<template>
  <!-- 舱位承运人维护 -->
  <div>
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :title="this.$t('CargoMsg.Cargo_NewSpaceCarrier')"
      inline-message
      :width="isZh ? '1000px' : '1200px'"
    >
      <el-form
        ref="form"
        :model="form"
        :label-width="isZh ? '80px' : '100px'"
        label-position="left"
      >
        <el-row :gutter="10">
          <el-col :xs="8" :sm="8" :md="8">
            <el-form-item :label="$t('Partners.carrierType')">
              <el-radio-group v-model="form.carrierType" no="carrierType" @change="carrierTypeChangeHandler">
                <el-radio no="shippingCompany" :label="0">{{ $t('SeaExport.ShippingCompany') }}</el-radio>
                <el-radio no="airlineCompany" :label="1">{{ $t('SeaExport.AirlineCompany') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item required :label="$t('CargoMsg.Cargo_Contact')">
              <el-input
                v-model="form.contact"
                v-uppercase
                no="contactName"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="8" :sm="8" :md="8">
            <el-form-item :label="$t('Partners.bookingMethod')">
              <el-select
                v-model="form.bookingMode"
                no="bookingMode"
                style="width:170px;"
              >
                <el-option
                  v-for="item in bookingModes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item :label="$t('CargoMsg.Cargo_ContactNumber')">
              <el-input
                v-model="form.contactNumber"
                v-uppercase
                no="contactNumber"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="8" :sm="8" :md="8">
            <el-form-item />
          </el-col> <!-- 空的占位列 -->
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item :label="$t('CargoMsg.Cargo_email')">
              <el-input
                v-model="form.email"
                v-uppercase
                no="email"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-tabs
          v-if="innerVisible"
          v-model="activeTabName"
          type="card"
          style="width:100%;"
        >
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_Carrier')"
            name="carrierGroup"
          >
            <cabin-group-tab ref="carrier-group" :detail-value="carrierDetailValue" :lob="form.lob" :status="innerStatus" group-name="CARRIER" @func="getDataFormCarrier" />
          </el-tab-pane>

          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_PortOfLoading')"
            name="polGroup"
          >
            <cabin-group-tab ref="pol-group" :detail-value="polDetailValue" :status="innerStatus" :lob="form.lob" :is-need-change-port="isNeedChangePort" group-name="POL" @func="getDataFormPolGroup" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_DestinationPort')"
            name="podGroup"
          >
            <cabin-group-tab ref="pod-group" :detail-value="podDetailValue" :status="innerStatus" :lob="form.lob" :is-need-change-port="isNeedChangePort" group-name="POD" @func="getDataFormPodGroup" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_ShippingRouteArea')"
            name="saGroup"
          >
            <cabin-group-tab ref="sa-group" :detail-value="saDetailValue" :status="innerStatus" group-name="REGION" @func="getDataFormSa" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_Country')"
            name="countryGroup"
          >
            <cabin-group-tab ref="country-group" :detail-value="countryDetailValue" :status="innerStatus" group-name="COUNTRY" @func="getDataFormCountry" />
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer">
        <span style="padding-right: 5px;">
          <!--确定/取消-->
          <el-button no="confirm" type="primary" @click="submitCabinCarrier">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import groupTab from '@/views/cargo/v0/Information/components/costPlan/groupTab'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import BusinessCopyWindow from '@/components/Cargo/Job/businessCopyWindow.vue'
import CabinGroupTab from '@/views/cargo/v0/Information/components/partner/tab/cabinGroupTab.vue'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'CabinCarrier',
  components: { CabinGroupTab, BusinessCopyWindow, cargoAdvanceSelect, groupTab },
  props: {
    visible: { type: Boolean, required: true },
    status: { type: String, required: true },
    cabinScheme: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      url: URL,
      bookingModes: [
        { label: 'EDI', value: 0 },
        { label: this.$t('Partners.online'), value: 1 },
        { label: this.$t('Partners.paper'), value: 2 }
      ],
      form: {
        uuid: '',
        version: '',
        carrierType: 0,
        contact: '',
        carrierUuid: '',
        bookingMode: 0,
        contactNumber: '',
        email: '',
        lob: 'SE',
        branchId: ''
      },
      activeTabName: 'carrierGroup',
      // ====> 以下四个数组分别收集新增&维护方案弹窗页除费用明细外四个tab下的表格值,维护对应费用条件
      schemeCriteriaPolList: [],
      schemeCriteriaPoDList: [],
      schemeCriteriaCarrierList: [],
      schemeCriteriaSaList: [],
      schemeCriteriaCountryList: [],
      // <====
      polDetailValue: [],
      podDetailValue: [],
      carrierDetailValue: [],
      saDetailValue: [],
      countryDetailValue: [],
      innerStatus: 'add',
      isNeedChangePort: false,
      previousValue: ''
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isNew() {
      return !this.form.uuid
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        this.innerStatus = this.status
        // 必须在innerVisible赋值前执行，否则明细列表显示空白
        await this.onshow()
      }
      this.innerVisible = val
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.resetDialog()
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    carrierTypeChangeHandler(label) {
      // 切换类型时，将原承运人类型的carrierUuid暂存，切换回去时，还原回去
      if (label === 0) {
        this.form.lob = SystemConstants.SE.code
      } else {
        this.form.lob = SystemConstants.AE.code
      }
      const temp = this.form.carrierUuid
      this.form.carrierUuid = this.tempCarrierUuid
      this.tempCarrierUuid = temp
    },
    async onshow() {
      if (this.status !== 'edit') {
        return
      }
      const self = this
      Object.assign(self.form, this.cabinScheme)
      // 解析出条件列表
      const cabinCriteria = this.cabinScheme.schemeCriteriaVOList || []
      // 承运人
      const carrierDetail = cabinCriteria.filter(item => item['criteriaType'] === SystemConstants.CARRIER.code)
      // 起运港
      const polDetail = cabinCriteria.filter(item => item['criteriaType'] === SystemConstants.POL.code)
      // 目标港
      const podDetail = cabinCriteria.filter(item => item['criteriaType'] === SystemConstants.POD.code)
      // 航线/区域
      const saDetail = cabinCriteria.filter(item => item['criteriaType'] === SystemConstants.REGION.code)
      // 国家
      const countryDetail = cabinCriteria.filter(item => item['criteriaType'] === SystemConstants.COUNTRY.code)
      // 1. 分别为负责传值给子组件的xxxValue变量赋值 2. 分别为存储最终结果的各项xxxList变量赋值
      self.schemeCriteriaCarrierList = [...carrierDetail]
      self.carrierDetailValue = [...carrierDetail]
      self.polDetailValue = [...polDetail]
      self.schemeCriteriaPolList = [...polDetail]
      self.podDetailValue = [...podDetail]
      self.schemeCriteriaPoDList = [...podDetail]
      self.schemeCriteriaSaList = [...saDetail]
      self.saDetailValue = [...saDetail]
      self.schemeCriteriaCountryList = [...countryDetail]
      self.countryDetailValue = [...countryDetail]
    },
    getDataFormCarrier(data) {
      this.schemeCriteriaCarrierList = [...data]
    },
    getDataFormPolGroup(data) {
      this.schemeCriteriaPolList = [...data]
    },
    getDataFormPodGroup(data) {
      this.schemeCriteriaPoDList = [...data]
    },
    getDataFormSa(data) {
      this.schemeCriteriaSaList = [...data]
    },
    getDataFormCountry(data) {
      this.schemeCriteriaCountryList = [...data]
    },
    // 条件数据组合
    schemeCriteriaList() {
      return [
        ...this.schemeCriteriaPolList,
        ...this.schemeCriteriaPoDList,
        ...this.schemeCriteriaCarrierList,
        ...this.schemeCriteriaSaList,
        ...this.schemeCriteriaCountryList
      ]
    },
    async submitCabinCarrier() {
      const schemeCriteriaVOList = this.schemeCriteriaList()
      // 组建请求数据
      const params = {
        ...this.form,
        schemeCriteriaVOList
      }
      params.branchId = this.$store.getters.currentOfficeId
      this.$emit('func', params)
    },
    resetDialog() {
      this.schemeCriteriaPolList = []
      this.schemeCriteriaPoDList = []
      this.schemeCriteriaCarrierList = []
      this.schemeCriteriaSaList = []
      this.schemeCriteriaCountryList = []
      // <====
      this.polDetailValue = []
      this.podDetailValue = []
      this.carrierDetailValue = []
      this.saDetailValue = []
      this.countryDetailValue = []
      this.resetForm()
      this.innerStatus = 'add'
    },
    resetForm() {
      this.form = {
        uuid: '',
        version: '',
        carrierType: 0,
        contact: '',
        carrierUuid: '',
        bookingMode: 0,
        contactNumber: '',
        email: '',
        lob: 'SE',
        branchId: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  /deep/ .el-select__tags {
    & > span {
      width: 100%;
      box-sizing: border-box;
      padding-left: 10px;
      display: flex;

      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
